/* eslint-disable react/prop-types */
import { Modal } from "flowbite-react";
import React, { useCallback, useEffect } from "react";

import { GrDocumentPdf, GrDownload } from "react-icons/gr";
import UserTimingModal from "../user-timing-modal/UserTimingModal";
import { CustomModal } from "../../pages/new-request-callback/create-order-modal/create-order-modal";
// import { DeleteOrderModal } from "../../pages/new-request-callback/deleteOrder/deleteOrderModal";
// import Cookies from "js-cookie";
// import { ROLES } from "../../utils/constants";
import { getPrescriptionFromRequest, getPrescriptionsFromLogs, getRequestCallbackDetails } from "../../pages/future-orders/helper";
import moment from "moment";

function ActionModal({ prescription, original, setSelectedHamburger, selectedHamburger }) {


    const [prescriptionModal, setPrescriptionModal] = React.useState(false);
    const [timingModal, setTimingModal] = React.useState(false);

    const [logsPrescriptions, setLogsPrescriptions] = React.useState({
        links: [],
        formattedLinks: []
    });

    React.useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                setSelectedHamburger(null);
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [setSelectedHamburger]);

    // const roles = Cookies.get("roles") && JSON.parse(Cookies.get("roles"))

    const handleDownloadAll = useCallback(() => {
        new Promise((resolve) => {
            const temporaryDownloadLink = document.createElement("a");
            temporaryDownloadLink.style.display = "none";
            document.body.appendChild(temporaryDownloadLink);
            resolve(temporaryDownloadLink);
        })
            .then((temporaryDownloadLink) => {
                const downloadPromises = [];
                if (logsPrescriptions.links.length > 0) {
                    for (const [index, downloadLink] of logsPrescriptions.links.entries()) {
                        const downloadPromise = new Promise((resolve) => {
                            setTimeout(() => {
                                const fileName = downloadLink.split("/").pop();
                                temporaryDownloadLink.setAttribute("href", downloadLink);
                                temporaryDownloadLink.setAttribute("download", fileName);
                                temporaryDownloadLink.click();
                                resolve(temporaryDownloadLink);
                            }, 1000 * index);
                        });
                        downloadPromises.push(downloadPromise);
                    }
                } else {
                    for (const [index, downloadLink] of prescription.entries()) {
                        const downloadPromise = new Promise((resolve) => {
                            setTimeout(() => {
                                const fileName = downloadLink.split("/").pop();
                                temporaryDownloadLink.setAttribute("href", downloadLink);
                                temporaryDownloadLink.setAttribute("download", fileName);
                                temporaryDownloadLink.click();
                                resolve(temporaryDownloadLink);
                            }, 1000 * index);
                        });
                        downloadPromises.push(downloadPromise);
                    }
                }
                return Promise.all(downloadPromises);
            })
            .then(([temporaryDownloadLink]) => {
                document.body.removeChild(temporaryDownloadLink);
            });
    }, [prescription, logsPrescriptions]);

    useEffect(() => {
        (async () => {
            if (prescriptionModal) {
                const requestCallbackDetails = await getRequestCallbackDetails(original.id);
                const sortedLogs = requestCallbackDetails?.logs?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                if (sortedLogs) {
                    const prescriptions = await getPrescriptionsFromLogs(sortedLogs);
                    setLogsPrescriptions(prescriptions);
                }
            }
        })();
    }, [prescriptionModal]);


    return <React.Fragment >
        <>
            <div className="relative">
                <button onClick={() => selectedHamburger === original.id ? setSelectedHamburger(null) : setSelectedHamburger(original.id)} className="bg-gray-200 hover:bg-gray-300 p-2 rounded-md">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
                {selectedHamburger === original.id && <div onClick={() => setSelectedHamburger(null)} className='fixed top-0 left-0 w-full h-full z-[50] bg-black opacity-50' />}
                {selectedHamburger === original.id && (
                    <div className="absolute right-0 mt-2 w-48 bg-white-50 rounded-md shadow-lg z-[100] border border-gray-200">
                        <div className="py-1">
                            {<button
                                onClick={() => {
                                    setPrescriptionModal(true);
                                }}
                                className="w-full text-left px-2 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                                View
                            </button>}
                            {original?.userMappingId && <button
                                onClick={() => {
                                    setTimingModal(true);
                                }}
                                className="w-full text-left px-2 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                                Timings
                            </button>}
                            {original?.userMappingId && <CustomModal callback={original} />}
                            {/* {(roles.includes(ROLES.ADMIN) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT)) && <DeleteOrderModal callback={original} />} */}
                            {<UserTimingModal show={timingModal} onClose={setTimingModal} original={original} />}

                            {<Modal style={{ width: '100vw' }}
                                className="w-full flex justify-center"
                                onClick={() => { setPrescriptionModal(false) }}
                                show={prescriptionModal}
                                size={'100vw'}
                                onClose={() => {
                                    setPrescriptionModal(false)
                                }}>
                                <Modal.Header style={{ backgroundColor: "white", width: "36vw", marginLeft: "32vw" }}>
                                    Prescriptions
                                </Modal.Header>
                                <Modal.Body
                                    style={{ backgroundColor: "white", width: "36vw", marginLeft: "32vw" }}
                                    className="flex justify-center overflow-hidden"
                                >
                                    {
                                        prescriptionModal ?
                                            <div style={{ height: "80vh", gap: '20px', paddingBottom: '100px', }}>
                                                {
                                                    prescription.length > 0 || logsPrescriptions.formattedLinks.length > 0 ?
                                                        <div className="flex flex-col h-[78vh]" >
                                                            <div className="flex flex-col gap-[50px] flex-1 overflow-scroll" >
                                                                {
                                                                    logsPrescriptions.formattedLinks.length > 0 ? logsPrescriptions.formattedLinks.map(logPrescription => {
                                                                        return <div key={logPrescription.date} className="h-[100%] flex flex-col gap-[10px]">
                                                                            {
                                                                                <div className="flex flex-col gap-[10px] h-[100%] items-center">
                                                                                    <h3 className="text-lg text-black font-bold text-center">{moment(logPrescription.date).format('DD-MM-YYYY - hh:mm A')}</h3>
                                                                                    {
                                                                                        logPrescription.links.map((link) => {
                                                                                            return link.includes('.pdf') ?
                                                                                                <div className="h-[100px] flex flex-col justify-center items-center">
                                                                                                    <a href={link} className="p-4 border text-2xl h-[80%] border-gray-300 rounded-lg flex flex-row gap-5 items-center">
                                                                                                        <GrDocumentPdf className="text-4xl" />
                                                                                                        {link.split('/')[3]}
                                                                                                        <GrDownload className="text-4xl" />
                                                                                                    </a>
                                                                                                </div> : <img key={link} src={link} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    }) : getPrescriptionFromRequest(original).map(prx => {
                                                                        return <div key={prx.date} className="h-[100%] flex flex-col gap-[10px]">
                                                                            {
                                                                                <div className="flex flex-col gap-[10px] h-[100%] items-center">
                                                                                    <h3 className="text-lg text-black font-bold text-center">{moment(prx.date).format('DD-MM-YYYY - hh:mm A')}</h3>
                                                                                    {
                                                                                        prx.links.map((link) => {
                                                                                            return link.includes('.pdf') ?
                                                                                                <div className="h-[100px] flex flex-col justify-center items-center">
                                                                                                    <a href={link} className="p-4 border text-2xl h-[80%] border-gray-300 rounded-lg flex flex-row gap-5 items-center">
                                                                                                        <GrDocumentPdf className="text-4xl" />
                                                                                                        {link.split('/')[3]}
                                                                                                        <GrDownload className="text-4xl" />
                                                                                                    </a>
                                                                                                </div> : <img key={link} src={link} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    })
                                                                }
                                                            </div>
                                                            <button disabled={!prescription} className="w-full py-[10px] bg-elm-500 rounded-[6px] text-white-50 hover:opacity-70" onClick={handleDownloadAll} >Download All</button>
                                                        </div> : "No Prescription Found !"
                                                }
                                            </div> : null}
                                </Modal.Body>

                            </Modal>
                            }
                        </div>
                    </div>
                )}
            </div>
        </>
    </React.Fragment>
}

export { ActionModal };